import React, { FC } from 'react';
import styled from 'styled-components';
import Loader from 'src/components/widgets/loader';
import { panel } from './scene-properties-panel/panelTheme';

// L'ATTESA DI UN AMBIENTE DI AUTHORING — i pallini del marchio, dentro una card che dice cosa sta
// succedendo.
//
// UN VELO MUTO SI LEGGE COME UN BLOCCO. Caricare una scena 3D o la struttura di un prodotto prende
// secondi veri: senza una parola, chi guarda non sa se sta aspettando o se si è rotto qualcosa, e
// chi non vede lo schermo non sa nemmeno che c'è un'attesa in corso. Per questo la card porta un
// titolo, una riga di spiegazione e un `aria-live`: l'attesa si annuncia.
//
// STA QUI E NON DENTRO UN AMBIENTE perché gli ambienti sono due — il Composer e lo Scene Editor —
// e si entra in attesa in tutti e due. Due copie della stessa card divergono alla prima modifica,
// e allora i due ambienti smettono di sembrare la stessa piattaforma proprio nel momento in cui
// non si può fare altro che guardarli.
//
// I COLORI SONO I TOKEN DEL PANNELLO, non i `--composer-*` da cui questa card è nata: quelle
// variabili vivono solo dentro il Composer, e qui fuori non esisterebbero. I valori coincidono —
// i ripieghi dei token sono gli stessi esadecimali — quindi il Composer non cambia di un pixel, e
// in più il giorno in cui la palette si accende anche altrove la card la segue invece di restare
// indietro col bianco scritto a mano.

const Veil = styled.div`
    position: absolute;
    inset: 0;
    z-index: 40;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(239, 243, 247, 0.9);
    backdrop-filter: blur(2px);
`;

const Card = styled.div`
    width: min(420px, 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding: 28px;
    border: 1px solid ${panel.line};
    border-radius: 10px;
    background: ${panel.surface};
    box-shadow: 0 16px 45px rgba(30, 42, 56, 0.16);
    text-align: center;
`;

const Title = styled.strong`
    color: ${panel.ink};
    font-size: 16px;
`;

const Line = styled.span`
    color: ${panel.inkMuted};
    line-height: 1.5;
`;

export type EditorLoadingCardProps = {
    /** Che cosa si sta caricando o salvando, in una riga. */
    title: string;
    /** Le righe sotto il titolo: una spiegazione, o un'istruzione da rispettare fino alla fine. */
    lines: React.ReactNode[];
};

export const EditorLoadingCard: FC<EditorLoadingCardProps> = ({ title, lines }) => (
    <Veil role='status' aria-live='polite'>
        <Card>
            <Loader />
            <Title>{title}</Title>
            {lines.map((line, index) => (
                <Line key={index}>{line}</Line>
            ))}
        </Card>
    </Veil>
);

export default EditorLoadingCard;
